module.exports = __webpack_public_path__ + "static/hermit-4e22e2b1b9c89c3476496651217b161b.svg";